/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Week_MondayInputs */



/**
* | output |
* | --- |
* | "Monday" |
*
* @param {Settings_Week_MondayInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const settings_week_monday = /** @type {((inputs?: Settings_Week_MondayInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Week_MondayInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Maandag")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Lundi")
	return /** @type {LocalizedString} */ ("Monday")
});